export default __webpack_public_path__ + "static/media/vm-mic.e4539f6d.svg";